<template>
  <div class="move-from-excluded-summary-popup">
    <popup :title="`ה${incomeOrExpense} תעבור`"
           :buttons="buttonOptions"
           :back-action="back">
      <template v-slot:content>
        <change-category-path :old-category="originalCategory" :new-category="selectedCategory" />
        <transaction-details :transaction="transaction" />
      </template>
    </popup>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseUI from '@riseupil/base-ui';
import EventBus from '@/event-bus/event-bus';
import * as HamsterApi from '@/api/HamsterApi';
import { removePlanRelatedTransactions } from '@/api/PlanAheadApi';
import cashflowNormalizer from '@/store/utilities/cashflow-normalizer';
import SegmentTracker from '@/mixins/SegmentTracker';
import Segment from '@/Segment';
import MoveFromExcludedConfirmationPopup from './MoveFromExcludedConfirmationPopup.vue';
import TransactionDetails from './TransactionDetails.vue';
import ChangeCategoryPath from './ChangeCategoryPath.vue';
import TransactionMovedToaster from '../../../../../toasters/TransactionMovedToaster';

export default {
  name: 'MoveFromExcludedSummaryPopup',
  components: {
    Popup: BaseUI.Popup,
    TransactionDetails,
    ChangeCategoryPath,
  },
  mixins: [SegmentTracker],
  created() {
    this.initTracker('MoveFromExcludedSummaryPopup_');
    this.track('Shown', this.logData);
  },
  computed: {
    ...mapState('editTransaction', ['transaction', 'categoryRuleType']),
    ...mapGetters('editTransaction', ['selectedCategory', 'originalCategory', 'categoryToVariant', 'isIncomeCategory', 'incomeOrExpense']),
    buttonOptions() {
      return [{
        title: 'אישור',
        size: 'slim',
        action: this.onSave,
        variant: 'primary',
      }];
    },
    isPlanAheadTransaction() {
      return !!this.transaction?.plan;
    },
    logData() {
      return {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
        isIncomeCategory: this.isIncomeCategory,
        transactionId: this.transaction.transactionId,
        isPlanAheadTransaction: this.isPlanAheadTransaction,
      };
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    ...mapActions('editCashflow', ['moveExcludedToVariableIncome', 'moveExcludedToVariableExpense']),
    ...mapActions('planAhead', ['removeTransactionFromPlan']),
    back() {
      this.track('BackClicked', this.logData);
      this.$emit('close');
      this.openModal({
        component: MoveFromExcludedConfirmationPopup,
        props: {},
      });
    },
    async onSave() {
      await HamsterApi.unmarkAsSavingTransaction(this.transaction.transactionId);
      this.track('ConfirmClicked', this.logData);
      this.$emit('close');
      if (this.isIncomeCategory) {
        await this.moveExcludedToVariableIncome({
          transactionId: this.transaction.transactionId,
        });
      } else {
        if (this.isPlanAheadTransaction) {
          const planId = this.transaction.plan;
          const { transactionId } = this.transaction;
          Segment.trackUserGot('RemoveTransactionFromPlan', { planId, transactionId });
          cashflowNormalizer.removeRelatedTransaction(planId, transactionId);
          this.removeTransactionFromPlan({ planId, transactionId });
        }
        await Promise.all(_.compact([
          this.isPlanAheadTransaction && removePlanRelatedTransactions(this.transaction.plan, [this.transaction.transactionId]),
          this.moveExcludedToVariableExpense({
            transactionId: this.transaction.transactionId,
          }),
        ]));
      }

      EventBus.$emit('open-toaster', {
        component: TransactionMovedToaster,
        props: {
          changedTransaction: this.transaction,
          targetCategory: this.selectedCategory,
        },
      });
    },
  },
};
</script>

<style lang="scss">
  @import '~@riseupil/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .move-from-excluded-summary-popup {

    .change-category-path {
      margin-bottom: 40px;
    }

    .transaction-details {
      margin-bottom: 24px;
    }

    .explanation {
      font-weight: bold;
      line-height: 16px;

      @include category-color;
    }
  }

</style>
